module.exports = "\r\n    <router-outlet></router-outlet>\r\n"


//////////////////
// WEBPACK FOOTER
// G:/Projekty/swaythegame/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main